import React, { useEffect, useState } from 'react';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import AxiosClient from '../../assets/AxiosClient.js';
import PaperRow from './PaperRow.jsx';
import Loader from '../../assets/tools/Loder/loader';
import { DataTable, PageHeader } from '../../componants/Workspace';

const Papers = () => {
  const { SetNotification } = useStateContext();
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [papersPerPage] = useState(7);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get('/papers/conferences/1');
        const { papers } = await response.data;
        setPapers(papers);
      } catch (error) {
        SetNotification('Error fetching data:', 'danger');
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const indexOfLastPaper = currentPage * papersPerPage;
  const indexOfFirstPaper = indexOfLastPaper - papersPerPage;
  const currentPapers = papers.slice(indexOfFirstPaper, indexOfLastPaper);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <PageHeader
        title="Papers"
        description="Review submitted papers, downloads, and review status."
      />
      {loading ? (
        <div className="workspace-loading"><Loader label="Loading papers..." /></div>
      ) : papers.length === 0 ? (
        <div className="workspace-empty">No papers are available.</div>
      ) : (
        <DataTable>
            <thead>
              <tr className='ro2'>
                <th className='col-2'>Researcher Name</th>
                <th className='col-2'>Paper Title</th>
                <th className='col-2'>Download</th>
                <th className='col-3'>Status</th>
                <th className='col-3'>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentPapers.map((paper) => <PaperRow key={paper.id} paper={paper} />)}
            </tbody>
        </DataTable>
      )}
      {!loading && papers.length > papersPerPage && (
        <nav className="workspace-pagination" aria-label="Paper pages">
          <ul className="pagination mb-0">
            {Array.from({ length: Math.ceil(papers.length / papersPerPage) }, (_, index) => (
              <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                <button className="page-link" onClick={() => paginate(index + 1)} aria-current={currentPage === index + 1 ? 'page' : undefined}>
                  {index + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </>
  );
};

export default Papers;